import { Navigate } from "react-router-dom";

function ProtectedRoute({ children, allowedRoles }) {
  const token = localStorage.getItem("token");
  let user = null;
  try {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      user = JSON.parse(storedUser);
    }
  } catch (error) {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  }
  // غير مسجل دخول
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // مسجل دخول لكن دوره غير مسموح
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/orders" replace />;
  }

  return children;
}

export default ProtectedRoute;
